// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"e060dd95","896":"ce2d2813"}[chunkId] + ".chunk.js";
};